module.exports = "<button (click)=\"onClick()\" [class]=\"buttonClass\">\n\t<i [class]=\"iTagClass\"></i>&nbsp;{{renderValue}}\n</button>\n"